import React, { Component } from 'react'
import axios from 'axios';
import {axiosEH} from './common/functions'
const Joi = require('joi');

class LoginForm extends Component {
  constructor() {
    super()
    this.state = {
      username: '',
      password: '',
      statusMsg: ''
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value.trim()
    })
  }

  handleSubmit(event) {
    event.preventDefault();
    const username = this.state.username;
    const password = this.state.password;

    const minLen = parseInt(process.env.REACT_APP_USER_INP_MIN_LEN);
    const schema = Joi.object().keys({
      username: Joi.string().min(minLen).required(),
      password: Joi.string().min(minLen).required(),
    });
    const dataToVal = { username, password };
    const ret = schema.validate(dataToVal);
    const { error, value } = ret;
    if (error) {
      var arr = error.details;
      const msg = arr[0];
      this.setState({ statusMsg: String(msg.message) });
      return;
    }

    const url = process.env.REACT_APP_BASEURL + '/username/login';
    console.log("url: ", url);
    console.log(this.state.username, this.state.password);
    axios.post(url, {
      username: this.state.username,
      password: this.state.password
    })
      .then(res => {  // {user token}
        if (res.status == 200) {
          //console.log("dft res.data: ", res.data)
          sessionStorage.setItem('user', JSON.stringify(res.data));
          if (res.data.hasOwnProperty('firstLanguage')) {
            sessionStorage.setItem('firstLanguage', res.data.firstLanguage);
          } else {
            sessionStorage.setItem('firstLanguage', 'English');
          }
        }
        this.setState({ statusMsg: '' });
        window.location.href = "/task";

        // set default class
        const classObjStr = process.env.REACT_APP_classdefault;
        const classObj = JSON.parse(classObjStr)
        localStorage.setItem('selectedClassname', classObj["className"]);
        localStorage.setItem('sc-taskDueDays', classObj["taskDueDays"]);
        localStorage.setItem('sc-spellingTimeoutSec', classObj["spellingTimeoutSec"]);
      })
      .catch(err => { 
        this.setState({ statusMsg: axiosEH(err) });
      })
  }

  render() {
    return (
      <section className="login-form is-medium mx-5" style={{ maxWidth: "100%" }} >
        <input className="input is-danger" type="text" name="username" placeholder="Username"
          value={this.state.username.trim()}
          maxLength={process.env.REACT_APP_USER_INP_MAX_LEN}
          onChange={this.handleChange}>
        </input>

        <input className="input is-danger" type="password" name="password" placeholder="Password"
          value={this.state.password.trim()}
          maxLength={process.env.REACT_APP_USER_INP_MAX_LEN}
          onChange={this.handleChange}>
        </input> <br></br>

        <button className="button is-success" onClick={this.handleSubmit}>
          Login
        </button>

        <br></br>
        <label className="label has-text-success">{this.state.statusMsg}</label>
      </section>
    )
  }
}

export default LoginForm